import PropTypes from 'prop-types';

export const HeroPropType = PropTypes.shape({
  title: PropTypes.string,
  videoUrl: PropTypes.string,
  imageUrl: PropTypes.string,
  readMoreText: PropTypes.string,
  url: PropTypes.string,
  backgroundColor: PropTypes.string,
});
